import React from 'react'
import PropTypes from 'prop-types'
import {TextInput} from '@/components/atoms'
import PointsCondition from './PointsCondition'
import styles from '../RewardSetup.module.scss'
import {useAppSelector} from '@/store'
import {getCurrencySymbol} from '@/utils/commons'
import { preventInvalidNumericInput } from '@/utils/inputValidations'

/**
 * CashDiscountCondition component displays the cash/discount/pepvoucher discount reward condition UI
 * Handles currency symbol (country code dependent), value input, and points input
 *
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing value, points
 * @param {Function} props.handleValueChange - Handler for value changes
 * @param {Function} props.handlePointsChange - Handler for points input changes
 * @param {string} props.valueError - Error message for value validation
 * @param {string} props.pointsError - Error message for points validation
 * @returns {JSX.Element} The rendered CashDiscountCondition component
 */
const CashDiscountCondition = ({
  formData,
  handleValueChange,
  handlePointsChange,
  valueError,
  pointsError,
}) => {
  const countryCode = useAppSelector(state => state.countryCode).countryCode
  const currencySymbol = getCurrencySymbol(countryCode)

  // For CASH, DISCOUNT, and PEP_VOUCHER_DISCOUNT, show currency symbol and value input
  return (
    <div className="flex flex-wrap gap-[13px]">
      <span className="text-sm whitespace-nowrap mt-2">{currencySymbol}</span>
      <div className={`w-32 ${styles.rewardSetup__inputPoints}`}>
        <TextInput
          className='placeholder:text-sm text-sm'
          value={formData.value}
          onChange={handleValueChange}
          label=""
          placeholderText="Value"
          handleKeyDown={preventInvalidNumericInput}
          error={valueError}
          isDark={true}
          type="number"
          id="reward-value"
        />
      </div>
      <PointsCondition formData={formData} handlePointsChange={handlePointsChange} pointsError={pointsError} />
    </div>
  )
}

CashDiscountCondition.propTypes = {
  formData: PropTypes.shape({
    rewardType: PropTypes.string,
    value: PropTypes.string,
    points: PropTypes.string,
  }).isRequired,
  handleValueChange: PropTypes.func.isRequired,
  handlePointsChange: PropTypes.func.isRequired,
  valueError: PropTypes.string,
  pointsError: PropTypes.string,
}

export default CashDiscountCondition

